import { Exception } from "@studyportals/mb-platform-exceptions";
import * as https from "https";
import * as superagent from "superagent";
import * as Url from "url";
import { BOBEnvironment } from "../../express/bob-environment";
import { IFetchResponse } from "../../utils/fetch-response.interface";

export class PageRepository {

	private host: string;
	private protocol: string;
	private port: string | null;

	constructor(host: string, protocol: string, port: string | null = null) {

		this.host = host;
		this.protocol = protocol;
		this.port = port;
	}

	public async get(path: string, headers: any): Promise<IFetchResponse> {

		const basePortalUrl = this.getPortalUrl();
		const portalUrl = `${basePortalUrl}${path}`;

		return this.retrievePortalPage(portalUrl, headers);
	}

	private getPortalUrl(): string {

		const urlObject = {
			host: this.host,
			protocol: this.protocol
		};

		let portalUrl = Url.format(urlObject);

		if (this.port !== null) {

			portalUrl += `:${this.port}`;
		}

		return portalUrl;
	}

	private getHttpsAgent() {

		return new https.Agent({
			rejectUnauthorized: false
		});
	}

	private async retrievePortalPage(url: string, headers: any): Promise<IFetchResponse> {

		let response = superagent
			.get(url)
			.set(this.parseIncomingHeaders(headers))
			.redirects(0)
			.timeout({
				response: 10000
			})
			// We don't want superagent to fail on any statuscode
			.ok(res => res.status);

		if (BOBEnvironment.ignoreSSLVerification()) {

			response = response.agent(this.getHttpsAgent());
		}

		try {

			response = await response;
		} catch (err) {

			response = this.handlePortalPageRequestError(err);
		}

		return {
			statusCode: response.status,
			headers: this.parseHeaders(response.headers),
			body: response.text
		};
	}

	private handlePortalPageRequestError(error: any): object {

		// TODO: Find out if reporting is necessary since this is already thrown and reported on a higher level
		// rollbar.error("Portal page request failed", error);

		if (error.code !== "ABORTED" || BOBEnvironment.getEnvironment() !== "tst") {
			throw new Exception("Portal page request failed", error);
		}

		return {
			status: 504,
			headers: {},
			text: "Portal page request timed-out..."
		};
	}

	private parseIncomingHeaders(headers: any): any {

		delete headers["accept-encoding"];
		delete headers["if-none-match"];
		delete headers["if-modified-since"];

		return headers;
	}

	private parseHeaders(headers: any): object {

		const newHeaders = {
			"X-BOB": true
		};

		Object.keys(headers).forEach(key => {

			if (key === "content-encoding") {

				return;
			}

			newHeaders[key] = headers[key];
		});

		return newHeaders;
	}
}
